import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import VisibleInDevelopment from '../../components/development/visible-in-development';
import DashboardCard from './components/dashboard-card';
import DashboardTitle from './components/dashboard-title';
import ArticleList from './articles/article-list';
import FieldsCard from './fields/card';
import WorksCard from './works/card';
import RelatedSystems from './related-systems';
import Calendar from './calendar';
import { faCow } from '@fortawesome/pro-solid-svg-icons';
import { can, route } from '../../services/utils';
import { RootState } from '../../store/store';
import { useHistory, useParams } from 'react-router-dom';
import { DASHBOARD } from '../../router/routes';
import { UrlParameters } from '../../enums/url-parameters';
import WeatherWidget from './weather';
import HeatStressIndex from './heat-stress';

export default function ExternalDashboard() {
  const { t } = useTranslation();

  const history = useHistory();

  const { farmUser, selectedFarm } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
    selectedFarm: state.global.farm,
  }));

  const { farmId }: { farmId: string } = useParams();

  if (farmId === UrlParameters.FARM_ID) {
    history.push(route(DASHBOARD, { farmId: selectedFarm.id }));
  }

  return (
    <div className="container mx-auto">
      <div className="md:grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        <div className="order-2">
          <WeatherWidget />

          {can(farmUser, { entity_type: 'work' }) && <Calendar />}

          <RelatedSystems />
        </div>

        <div className="order-3 md:col-span-2 xl:order-2">
          <HeatStressIndex />

          {can(farmUser, { entity_type: 'work' }) && <WorksCard />}

          {can(farmUser, { entity_type: 'field' }) && <FieldsCard />}

          <VisibleInDevelopment>
            <DashboardCard>
              <DashboardTitle
                title={t('pages.dashboard.animal_count.heading')}
                icon={faCow}
              />
            </DashboardCard>
          </VisibleInDevelopment>
        </div>

        <div className="order-1 xl:order-3">
          <ArticleList />
        </div>
      </div>
    </div>
  );
}
